import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute: React.FC = () => {
    const data: any = !!sessionStorage.getItem("data") ? JSON.parse(sessionStorage.getItem("data") as any) : null;
    return data?.token ? <Outlet /> : <Navigate to="/auth/login" />;
};

export default ProtectedRoute;